import PortalIdParser from 'PortalIdParser';

// TODO: adjust this to work for all apps. We can fetch app slug for this URL from HubSpot marketplace
export const getSettingsPageUrl = () => `/integrations-settings/${PortalIdParser.get()}/installed/slack/generalSettings`;
export const getGoogleChatMappingsUrl = () => `/integrations-settings/${PortalIdParser.get()}/installed/google-chat/generalSettings`;